import { post } from '../../../../../api/baseUrl';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../../store';
import { UpdateCatalogOrderSetPayload } from '../types';

export interface UpdateCatalogOrderSetFormValue
  extends Omit<UpdateCatalogOrderSetPayload, 'tenancyId'> {}

export const useUpdateCatalogOrderSet = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const postUpdateCatalogOrderSet = async (
    payload: UpdateCatalogOrderSetFormValue,
  ) => {
    if (!selectedTenancy) return;
    setIsLoading(true);
    try {
      await post(`updateCatalogOrderSet`, {
        ...payload,
        tenancyId: selectedTenancy.tenancy_id,
      });
    } catch (error: any) {
      console.error('An error occurred during updateCatalogOrderSet', error);
      setErrorMessage(
        error?.response?.data?.message ||
          'Unknown error in updateCatalogOrderSet',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    postUpdateCatalogOrderSet,
    errorMessage,
    isLoading,
  };
};
